import React from "react";
import styled from "styled-components";
import { Search as SearchIcon } from "@material-ui/icons";
import { RadioGroup, Radio, FormControlLabel, Grid, FormControl, InputLabel, Input, IconButton, InputAdornment } from "@material-ui/core";

const SearchInput = styled(Input)`
min-width: 265px;
`;

export default function GuestHeader(props) {
  const {
    handleChange,

    guestFilterText,
    guestGroupFilterText,

    viewByValue, options
  } = props;

  return (

    <>

      <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={0} style={{ marginBottom: "10px" }}>
        <Grid item xs={6} md={7}>
          <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={16}>
            <Grid item>
              <div className="title-component">GUEST PERMISSIONS</div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6} md={5}>
          <Grid container direction="row" justify="flex-end" alignItems="flex-end" spacing={16}>
            <Grid item xs={6}>
              {(viewByValue === 0 || viewByValue === "0") &&
                (
                  <FormControl fullWidth>
                    <InputLabel htmlFor="search">Search by Guest or Company</InputLabel>
                    <SearchInput
                      type="text"
                      id="guestFilterText"
                      name="guestFilterText"
                      value={guestFilterText}
                      onChange={({ target }) => handleChange("guestFilterText", target.value)}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton color="primary">
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                )}
              {(viewByValue === 1 || viewByValue === "1") &&
                (
                  <FormControl fullWidth>
                    <InputLabel htmlFor="search">Search by Guest Group</InputLabel>
                    <SearchInput
                      type="text"
                      id="guestGroupFilterText"
                      name="guestGroupFilterText"
                      value={guestGroupFilterText}
                      onChange={({ target }) => handleChange("guestGroupFilterText", target.value)}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton color="primary">
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={0} style={{ marginBottom: "10px" }}>
        <Grid item>
          <RadioGroup
            aria-label="Grid Pricing"
            name="Grid Pricing"
            value={viewByValue.toString()}
            onChange={({ target }) => handleChange("viewByValue", target.value)}
            row
          >
            {
              options.map(option => (
                <FormControlLabel
                  key={option.value}
                  value={option.value.toString()}
                  control={<Radio />}
                  label={option.name}
                />
              ))
            }
          </RadioGroup>
        </Grid>
      </Grid>
    </>
  );
}
